import { render, staticRenderFns } from "./RegistrationCompleted.vue?vue&type=template&id=6aff7f61"
import script from "./RegistrationCompleted.vue?vue&type=script&lang=js"
export * from "./RegistrationCompleted.vue?vue&type=script&lang=js"
import style0 from "./RegistrationCompleted.vue?vue&type=style&index=0&id=6aff7f61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports